export enum DiagnosisTypeCode {
  rfa = 'diagnosis.rfa',
  chronic = 'diagnosis.rfa.icd10code.chronic',
  acute = 'diagnosis.acute.icd10code',
  primary = 'diagnosis.authorization.icd10code.primary',
  secondary = 'diagnosis.authorization.icd10code.secondary',
}
export enum DiagnosisStatusCode {
  active = 'active',
  inactive = 'inactive',
}
